import React from 'react'
import loadingGraphic from '../images/loader.png'
import '../css/loader.scss'

const Loader = ({ children, loading }) => {
  if(loading) {
    return (
      <div className="appointment-scheduler-widget-loader">
        <img src={loadingGraphic} alt="Loading..." />
      </div>
    )
  }
  else {
    return children
  }
}

export default Loader
